import { NgModule, ApplicationRef, ErrorHandler } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from "@angular/http";
import { FormsModule } from "@angular/forms";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import { NgxPaginationModule } from "ngx-pagination";

import { AppComponent } from "./app.component";
import { PollsService } from "./polls/polls.service";
import { PollsComponent } from "./polls/polls.component";
import { CreatePollComponent } from "./polls/createpoll.component";
import { EditPollComponent } from "./polls/editpoll.component";
import { PollFilter } from "./polls/polls.filter";
import { AlertsComponent } from "./alerts/alerts.component";
import { AlertsService } from "./alerts/alerts.service";
import { CreateAlertComponent } from "./alerts/createalert.component";
import { EditAlertComponent } from "./alerts/editalert.component";
import { AlertFilter } from "./alerts/alerts.filter";
import { PostsComponent } from "./posts/posts.component";
import { CreatePostComponent } from "./posts/createpost.component";
import { EditPostComponent } from "./posts/editpost.component";
import { PostFilter } from "./posts/posts.filter";
import { ProfilesComponent } from "./profiles/profiles.component";
import { ApiService } from "./shared";
import { PostsService } from "./posts/posts.service";
import { ProjectsService } from "./projects/projects.service";
import { ProjectsComponent } from "./projects/projects.component";
import { CreateProjectComponent } from "./projects/createproject.component";
import { EditProjectComponent } from "./projects/editproject.component";
import { CompaniesService } from "./companies/companies.service";
import { CompaniesComponent } from "./companies/companies.component";
import { CreateCompanyComponent } from "./companies/createcompany.component";
import { EditCompanyComponent } from "./companies/editcompany.component";
import { routing } from "./app.routing";
import { ConfigService } from "./config.service";
import { PollResponsesService } from "./pollresponses/pollresponses.service";
import { PollResponsesComponent } from "./pollresponses/pollresponses.component";
import { NotificationsService } from "./notifications/notifications.service";
import { NotificationsComponent } from "./notifications/notifications.component";
import { CreateNotificationComponent } from "./notifications/createnotification.component";
import { NotificationFilter } from "./notifications/notifications.filter";
import { VisibilityComponent } from "./shared/visibility/visibility.component";
import { SuppliersComponent } from "./shared/suppliers/suppliers.component";
import { AccountsService } from "./accounts/accounts.service";
import { AccountListComponent } from "./accounts/accountlist.component";
import { AccountDetailComponent } from "./accounts/accountdetail.component";
import { UserDetailComponent } from "./accounts/userdetail.component";
import { CreateAccountComponent } from "./accounts/createaccount.component";
import { EditAccountComponent } from "./accounts/editaccount.component";
import { AccountFilter } from "./accounts/accounts.filter";
import { UsersService } from "./users/users.service";
import { UsersComponent } from "./users/users.component";
import { CreateUserComponent } from "./users/createuser.component";
import { EditUserComponent } from "./users/edituser.component";
import { UserFormComponent } from "./users/userform.component";
import { UserFilter } from "./users/users.filter";
import { ProjectMember } from "./projectmember/projectmember.service";
import { ModalComponent } from "./shared/modal/modal.component";
import { AddProjectModalComponent } from "./shared/modal/addprojectmodal.component";
import { EditProjPermissionModalComponent } from "./shared/modal/editprojectpermissionmodal.component";
import { AddUserModalComponent } from "./shared/modal/addusermodal.component";
import { EditUserModalComponent } from "./shared/modal/editusermodal.component";
import { OrderBy } from "./shared/orderby.pipe";
import { BindingsService } from "./bindings/bindings.service";
import { BindingsComponent } from "./bindings/bindings.component";
import { ProgramsService } from "./programs/programs.service";

import { removeNgStyles, createNewHosts } from "@angularclass/hmr";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ApplicationInsightsService } from "./logger/appinsights.service";
import { ApplicationInsightsErrorHandler } from "./logger/errorhandler.service";
import { BeforeDateValidatorDirective } from "./shared/beforedatevalidator.directive";
import { AfterDateValidatorDirective } from "./shared/afterdatevalidator.directive";
import { DateRangeValidatorDirective } from "./shared/daterangevalidator.directive";

@NgModule({
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    routing,
    NgxPaginationModule,
    NgbModule.forRoot()
  ],
  declarations: [
    AppComponent,
    PollsComponent,
    CreatePollComponent,
    EditPollComponent,
    PollFilter,
    AlertsComponent,
    CreateAlertComponent,
    EditAlertComponent,
    AlertFilter,
    PostsComponent,
    PostFilter,
    CreatePostComponent,
    EditPostComponent,
    ProfilesComponent,
    PollResponsesComponent,
    ProjectsComponent,
    VisibilityComponent,
    SuppliersComponent,
    NotificationsComponent,
    CreateNotificationComponent,
    NotificationFilter,
    AccountListComponent,
    AccountDetailComponent,
    UserDetailComponent,
    CreateAccountComponent,
    EditAccountComponent,
    AccountFilter,
    CreateProjectComponent,
    EditProjectComponent,
    UsersComponent,
    CreateUserComponent,
    UserFormComponent,
    EditUserComponent,
    UserFilter,
    ModalComponent,
    AddProjectModalComponent,
    EditProjPermissionModalComponent,
    AddUserModalComponent,
    EditUserModalComponent,
    OrderBy,
    CompaniesComponent,
    CreateCompanyComponent,
    EditCompanyComponent,
    BindingsComponent,
    BeforeDateValidatorDirective,
    AfterDateValidatorDirective,
    DateRangeValidatorDirective
  ],
  providers: [
    ApiService,
    PostsService,
    ConfigService,
    PollsService,
    PollResponsesService,
    ProjectsService,
    CompaniesService,
    AlertsService,
    NotificationsService,
    AccountsService,
    UsersService,
    BindingsService,
    ProgramsService,
    ProjectMember,
    ApplicationInsightsService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: ErrorHandler, useClass: ApplicationInsightsErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(public appRef: ApplicationRef) {}
  hmrOnInit(store) {
    console.log("HMR store", store);
  }
  hmrOnDestroy(store) {
    let cmpLocation = this.appRef.components.map(
      cmp => cmp.location.nativeElement
    );
    // recreate elements
    store.disposeOldHosts = createNewHosts(cmpLocation);
    // remove styles
    removeNgStyles();
  }
  hmrAfterDestroy(store) {
    // display new elements
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.module.ts